export const API_BASE_URL = "https://yash-gulati-be.pixoatic.in/api/v1";

export const API_ENDPOINTS = {
  homePages: `${API_BASE_URL}/home_pages`,
  abouts: `${API_BASE_URL}/abouts`,
  services: `${API_BASE_URL}/services`,
  awards: `${API_BASE_URL}/awards`,
  blogs: `${API_BASE_URL}/blogs`,
  contacts: `${API_BASE_URL}/contacts`,
  bookAppointments: `${API_BASE_URL}/book_appointments`,
  queries: `${API_BASE_URL}/queries`,
};
